import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import u from 'umbrellajs';
// import { useCookies } from 'react-cookie';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreState } from 'easy-peasy';
import { uid } from 'react-uid';
import { Sortable } from '@shopify/draggable';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import _e from 'common/localeUtil';
import GMButton from './button/GMButton';
import {
	checkElement2,
	checkWindowVariableChangedToTrue,
	findGrapesJSComponent,
	findGrapesJSComponents,
	getSectionsFromHTML,
	iFrameScrollTo,
	iFrameShowHide,
	setStyleGrapesJSComponentUsingAddStyle
} from '../utils';
import DragHandlerIcon from './icon/DragHandlerIcon';

const useStyles = makeStyles(theme => ({
	sectionWrapper: {
		fontSize: '1rem'
	},

	contentHeader: {
		paddingTop: theme.spacing(0.5),
		paddingLeft: theme.spacing(4),
		paddingRight: theme.spacing(4),
		paddingBottom: theme.spacing(2),
		fontWeight: 'bold'
	},
	wrapperStyle: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1)
	}
}));

const EditorLeftPanelSections = () => {
	const classes = useStyles();
	const [sections, setSections] = useState([]);
	const [hideEyes, setHideEyes] = useState({});
	const adviserData = useStoreState(state => state.template.adviserData);
	const template = useStoreState(state => state.template.template);
	const testimonials = useStoreState(state => state.template.testimonials);

	const addDragDropForSection = sectionSelector => {
		// Make sections draggable
		const drag = new Sortable(document.querySelectorAll(sectionSelector), {
			draggable: '.each-section-link',
			handle: '.each-section-movebar'
		});
		drag.on('sortable:stop', () => {
			// console.log('sortable:stop', e);
			checkElement2(`${sectionSelector}:not([class^="draggable"])`).then(() => {
				let i = 0;
				const copiedMenuArray = [];
				u(`${sectionSelector} .each-section-link`).each(node => {
					const sectionID = u(node).data('section-id');
					// console.log(sectionID, u(node).attr('class'));
					const aComp = findGrapesJSComponent(`${sectionID}`);
					if (aComp) {
						i += 1;
						setStyleGrapesJSComponentUsingAddStyle(`
							${sectionID} {
								order: ${i}
							}`);

						// Set order of menu too
						let comp = findGrapesJSComponent(`a[href="${sectionID}"]`);
						if (comp) {
							comp = comp.parent();
							if (comp) {
								// setStyleGrapesJSComponentUsingAddStyle(`
								// 		#${comp.getId()} {
								// 			order: ${i}
								// 		}`);
							}

							copiedMenuArray.push(comp);
						}

						window.gm_track(`Sections: Dragged/Dropped`, { sectionID, index: i });
					}
				});
				console.log('copiedMenuArray', copiedMenuArray);
				findGrapesJSComponent('.navbar-end').components(copiedMenuArray);

				// Unapply and apply OkayNav again
				window.grapesjs.Canvas.getWindow().unapplyAndApplyOkayNav?.();
			});
		});
		document.ontouchmove = function(event) {
			event.preventDefault();
		};
	};

	const generateShowHideStatusesSections = () => {
		const hideEyes = {};
		const comps = findGrapesJSComponents('a[href*="#section-"]');
		comps.forEach(comp => {
			const id = comp.attributes.attributes.href;

			const aComp = findGrapesJSComponent(`${id}`);
			const style = aComp?.getStyle() || {};
			// console.log('generateShowHideStatusesSections', style);
			// generateShowHideStatusesSections {order: "1"}
			// generateShowHideStatusesSections {order: "2", display: "none"}
			if (style.display === 'none') {
				hideEyes[id] = true;
			}
		});
		// console.log('generateShowHideStatusesSections hideEyes', hideEyes);
		setHideEyes(hideEyes);
	};

	useEffect(() => {
		checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
			console.log('checkWindowVariableChangedToTrue once');
			if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
				const sections_ = getSectionsFromHTML(testimonials);
				setSections(sections_);
				generateShowHideStatusesSections();
			}
		});
		checkElement2('.section-content').then(() => {
			addDragDropForSection('.section-content');
		});
	}, []);

	const handleClickTitle = _e => {
		// Handle click on section will scroll
		let sectionId = u(_e.currentTarget).data('section-id');
		if (!sectionId.startsWith('#')) {
			sectionId = `#${sectionId}`;
		}
		// if (window.HelpHero) {
		// 	if (sectionId === '#section-calculator' && !cookies['helphero-i90GYG0gwyh']) {
		// 		window.HelpHero.startTour('i90GYG0gwyh');
		// 		setCookie('helphero-i90GYG0gwyh', true);
		// 	}
		// 	if (sectionId === '#section-testimonials' && !cookies['helphero-q1Fafb3vFcG']) {
		// 		window.HelpHero.startTour('q1Fafb3vFcG');
		// 		setCookie('helphero-q1Fafb3vFcG', true);
		// 	}
		// }
		// console.log('.each-section-link a', sectionId);
		iFrameScrollTo(sectionId);

		// Toggle active class for a link
		u('.each-section-link a').removeClass('active');
		u('.each-section-link-main a').removeClass('active');
		u(_e.currentTarget).addClass('active');
	};

	const handleClickShowHide = _e => {
		const currentElement = _e.currentTarget;
		// Handle click show/hide icon of section
		const sectionId = u(currentElement).data('section-id-showhide');
		// console.log('.each-section-link a', sectionId);
		const isHiding = u(currentElement).hasClass('hideeye');

		window.gm_track(`Sections: Show/Hide section clicked`, { sectionId, isHiding });

		iFrameShowHide(`${sectionId}`, isHiding);
		u(currentElement).toggleClass('hideeye');
		setHideEyes({
			...hideEyes,
			[sectionId]: !isHiding
		});

		// Unapply and apply OkayNav again
		window.grapesjs.Canvas.getWindow().unapplyAndApplyOkayNav?.();
	};

	const generateSection = section => {
		// console.log('generateSection', section);
		// Ignore section-main
		if (section.id.includes('-main')) {
			return null;
		}
		const comp = findGrapesJSComponent(`${section.id}`);
		if (comp) {
			const isHiding = comp.getStyle().display === 'none';
			const thisClass = isHiding ? 'hideeye' : '';

			let sectionDraggable = true;
			if (section.id.includes('-main') && template !== 'template8') {
				sectionDraggable = false;
			}

			return (
				<li
					className={sectionDraggable ? 'each-section-link' : 'each-section-link-main'}
					data-section-id={section.id}
					key={uid(section)}
				>
					<div className="movebar-title">
						<div className="each-section-movebar">
							<GMButton SvgIcon={DragHandlerIcon} />
						</div>
						<div className="each-section-title">
							<a
								role="presentation"
								data-section-id={section.id}
								onClick={handleClickTitle}
							>
								{section.title}
							</a>
						</div>
					</div>
					<div className="each-section-icons">
						{sectionDraggable ? (
							<a
								role="presentation"
								data-section-id-showhide={section.id}
								className={thisClass}
								onClick={handleClickShowHide}
							>
								{hideEyes[section.id] ? (
									<GMButton Icon={VisibilityOffIcon} />
								) : (
									<GMButton Icon={VisibilityIcon} />
								)}
							</a>
						) : (
							<div className="dummy" />
						)}
					</div>
				</li>
			);
		}
		return null;
	};

	const generateSections = () => {
		if (sections.length === 0) return null;
		console.log('EditorLeftPanelSections', {
			sections
		});
		return (
			<div className={classes.sectionWrapper}>
				<div className={`${classes.wrapperStyle} content-sections-wrapper`}>
					<div className="section-title">{_e('sections')}</div>
					<div className="section-subtitle">{_e('drag_rearrange_sections')}</div>
					<div className="accordion-details">
						<ul className="section-content">
							{sections.map(section => generateSection(section))}
						</ul>
					</div>
				</div>
			</div>
		);
	};
	if (!adviserData?.id) {
		return false;
	}
	return <div className={classes.sectionsWrapper}>{generateSections()}</div>;
};

EditorLeftPanelSections.propTypes = {
	// changeBackgroundDialogOpen: PropTypes.bool
	// clickBackCallback: PropTypes.func.isRequired
};

export default EditorLeftPanelSections;
